export default __webpack_public_path__ + "static/img2-033667bf2c29c96e8eb82bd159b5c66b.png";